import React from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';

type Props = {
  isPluginEnabled?: boolean;
};

const S3Plugin = React.lazy(() => importFromS3('tcc-programs-plugin'));
const MFPlugin = React.lazy(() => import('programsPlugin/ProgramsPlugin'));

export const ProgramsPluginContainer: React.FC<Props> = () => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.programs-plugin.module-federation'];

  const ProgramsPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return <ProgramsPlugin />;
};
